import { useQuery } from '@tanstack/react-query';
import { useAPIClient } from '@/hooks/useAPIClient';
import { SessionDetailResponse } from '@/types/api';

export const useSessionDetail = (sessionId: string) => {
  const apiClient = useAPIClient();
  
  const sessionQuery = useQuery({
    queryKey: ['session', sessionId],
    queryFn: () => apiClient.sessions.get(sessionId),
    enabled: !!sessionId, // Only fetch if sessionId is provided
    staleTime: 300000, // Consider data stale after 5 minutes (was 1 minute)
    refetchInterval: false, // Disable automatic refetching (was 30s) 
    refetchOnWindowFocus: false, // Don't refetch when window gains focus
    refetchOnMount: false, // Don't refetch on component mount if data exists
    retry: 2,
  });

  const statsQuery = useQuery({
    queryKey: ['session-stats', sessionId],
    queryFn: () => apiClient.sessions.stats(sessionId),
    enabled: !!sessionId,
    staleTime: 30000,
    refetchInterval: 60000,
  });

  return {
    session: sessionQuery.data,
    isLoading: sessionQuery.isLoading,
    isError: sessionQuery.isError,
    error: sessionQuery.error,
    refetch: sessionQuery.refetch,
    stats: statsQuery.data,
    statsLoading: statsQuery.isLoading,
  };
};